import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { TestarAmbienteRequest } from '../../requests/orquestrador-dfe/testar-ambiente.request';
import { TestarAmbienteConfiguracaoDFeGeralResponse } from '../../responses/orquestrador-dfe/testar-ambiente-configuracao-dfe-geral.response';

@Injectable({
  providedIn: 'root',
})
export class ConfiguracaoDFeGeralService extends CommonService {
  constructor(
    private httpClient: HttpClient
  ) {
    super();
  }

  private readonly apiUrl = `${environment.urlApiOrquestradorDFe}ConfiguracaoDFeGeral`;

  /**
   * Consulta o status do serviço da SEFAZ no ambiente informado, com o certificado da empresa do token.
   * Corresponde a: [HttpPost] /ConfiguracaoDFeGeral/testar-ambiente
   */
  public testarAmbiente(request: TestarAmbienteRequest): Observable<TestarAmbienteConfiguracaoDFeGeralResponse> {
    return this.httpClient
      .post<TestarAmbienteConfiguracaoDFeGeralResponse>(`${this.apiUrl}/testar-ambiente`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
